import axios from 'axios';

const Api = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_API_URL,
});
const SECURE_API = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_API_URL,
});
SECURE_API.interceptors.request.use(
  (config) => {
    const Token = localStorage.getItem('token');
    // console.log('Api.js:12 ~ unParesdToken:', Token);
    // console.log(
    //   ':rocket: ~ file: Api.js:13 ~ ParesdToken exp:',
    //   JSON.parse(atob(Token.split('.')[1]))
    // );
    if (Token) {
      const tokenData = JSON.parse(atob(Token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      if (tokenData.exp && tokenData.exp < currentTime) {
        // window.location.href = '/login';
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        console.log('token has been expired');
        window.location.replace('/login');
      } else {
        config.headers.Authorization = `Bearer ${Token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const ApiCall = {
  SECURE_API,
  Api,
};
export default ApiCall;
